import { useState } from "react";
import DeleteModal from "../../../../common/DeleteModal";
import { useSelector } from "react-redux";
import editIcon from "../../../../../images/icons/edit.svg";
import trashIcon from "../../../../../images/icons/delete.svg";
import QrCodeValetService from "../../../../../services/QrCodeValetService";
import { usePermissions } from "../../../../common/permissions";

const CardItem = ({
	item,
	index,
	setShouldUpdate,
	setItem,
	setAddModal,
	setQrModal,
}) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const qrCodeValetService = new QrCodeValetService();
	const Auth = useSelector((state) => state.auth?.auth);
	const { canEdit, canDelete } = usePermissions();
	const lang = useSelector((state) => state.auth?.lang);

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item?.qr_group?.name}</td>
			<td>{lang === "en" ? item?.zone?.name_en : item?.zone?.name_ar}</td>
			<td>{item?.number}</td>
			<td>{item?.floor}</td>
			<td>
				{lang === "en"
					? item?.parking_slot?.name_en
					: item?.parking_slot?.name_ar}
			</td>
			<td>{item?.login_number}</td>

			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					<i
						class="las la-qrcode fs-24 cursor-pointer"
						onClick={() => {
							setItem(item);
							setQrModal(true);
						}}></i>
					{canEdit("qr_code_valet") && (
						<img
							src={editIcon}
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}
							className="cursor-pointer"
							alt="edit"
							width={24}
						/>
					)}
					{canDelete("qr_code_valet") && (
						<img
							src={trashIcon}
							onClick={() => setDeleteModal(true)}
							className="cursor-pointer"
							alt="trash"
							width={24}
						/>
					)}
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.qr_group?.name}
					deletedItem={item}
					modelService={qrCodeValetService}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
				/>
			)}
		</tr>
	);
};
export default CardItem;
